<template>
  <b-modal
    id="addEnteringBalanceModal"
    centered
    :title="$t('adding_an_incoming_balance')"
    size="md"
    :ok-title="$t('add')"
    no-close-on-backdrop
    :cancel-title="$t('general.cancel')"
    @hidden="setNull"
    @ok.prevent="addEnteringBalance"
  >
    <validation-observer ref="validationObserver">
      <!-- type input -->
      <b-form-group :label="$t('remain_type')" label-for="remain_type">
        <validation-provider
          #default="{ errors }"
          :name="$t('remain_type')"
          rules="required"
        >
          <v-select
            v-model="type"
            id="remain_type"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :clearable="false"
            :placeholder="$t('remain_type')"
            label="title"
            :options="typeProduct"
            :reduce="(option) => option.value"
            @input="onSelectType"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
      <template v-if="type === 'material'">
        <b-form-group :label="$t('reference.categoriya')" label-for="name">
          <validation-provider
            #default="{ errors }"
            :name="$t('reference.categoriya')"
            rules="required"
          >
            <!-- gpc{{ GET_PRODUCT_CATEGORIES }} -->
            <v-select
              v-model="categoryMaterial"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :placeholder="$t('reference.categoriya')"
              label="title"
              :options="GET_PRODUCT_CATEGORIES.results"
              :reduce="(option) => option.id"
              @input="materialTypeGetByCategory"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group :label="$t('table.product_type')" label-for="name">
          <validation-provider
            #default="{ errors }"
            :name="$t('table.product_type')"
            rules="required"
          >
            <!-- <v-select
              id="name"
              v-model="material"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :placeholder="$t('table.product_type')"
              label="title"
              :options="GET_MATERIALS.results"
              :reduce="(option) => option.id"
              @input="onSelectMaterial"
            /> -->

            <v-select
              v-model="material"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :options="GET_MATERIALS.results"
              :filterable="false"
              :reduce="(option) => option.id"
              @input="onSelectMaterial"
              @search="onSearch1"
            >
              <li slot="list-footer" class="pagination">
                <button :disabled="!GET_MATERIALS.previous" @click="previous">
                  {{$t('prev')}}
                </button>
                <button :disabled="!GET_MATERIALS.next" @click="nextFunc">
                  {{$t('next')}}
                </button>
              </li>
            </v-select>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group v-if="material" :label="$t('reference.name')" label-for="material">
          <validation-provider
            #default="{ errors }"
            :name="$t('reference.name')"
            rules="required"
          >
            <v-select
              id="material"
              v-model="form.name"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :placeholder="$t('reference.name')"
              label="value"
              :options="GET_MATERIALS_FOR_ENTERING.results"
              :reduce="(option) => option.id"
            >
              <li slot="list-footer" class="pagination">
                <button
                  :disabled="!GET_MATERIALS_FOR_ENTERING.previous"
                  @click="previousEnter"
                >
                  {{$t('prev')}}
                </button>
                <button
                  :disabled="!GET_MATERIALS_FOR_ENTERING.next"
                  @click="nextFuncEnter"
                >
                  {{$t('next')}}
                </button>
              </li>
            </v-select>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </template>
      <template v-else-if="type === 'instrument'">
        <b-form-group :label="$t('reference.categoriya')" label-for="category">
          <validation-provider
            #default="{ errors }"
            :name="$t('reference.categoriya')"
            rules="required"
          >
            <!-- gI{{GET_INSTRUMENT_CATEGORIES}} -->
            <v-select
              id="category"
              v-model="category"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :placeholder="$t('reference.categoriya')"
              label="title"
              :options="GET_INSTRUMENT_CATEGORIES.results"
              :reduce="(option) => option.id"
              @input="onSelectCategory"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group v-if="category" :label="$t('sidebar.instrument')" label-for="instrument">
          <validation-provider
            #default="{ errors }"
            :name="$t('sidebar.instrument')"
            rules="required"
          >
            <v-select
              id="instrument"
              v-model="instrumentType"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :placeholder="$t('sidebar.instrument')"
              label="title"
              :options="GET_INSTRUMENTS_MODEL.results"
              :reduce="(option) => option.id"
              @input="onSelectMaterialType"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group
          v-if="instrumentType"
          :label="$t('reference.instruments_type')"
          label-for="instrumentType"
        >
          <validation-provider
            #default="{ errors }"
            :name="$t('reference.instruments_type')"
            rules="required"
          >
            <v-select
              id="instrumentType"
              v-model="form.name"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :placeholder="$t('reference.instruments_type')"
              label="title"
              :options="GET_INSTRUMENTS_FOR_ENTERING.results"
              :reduce="(option) => option.id"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </template>

      <b-form-group :label="$t('note')" label-for="note">
        <!-- <validation-provider
          #default="{ errors }"
          :name="$t('note')"
          rules="required"
        > -->
          <b-form-input
            id="note"
            v-model="form.note"
            :placeholder="$t('note')"
          />
          <!-- <small class="text-danger">{{ errors[0] }}</small> -->
        <!-- </validation-provider> -->
      </b-form-group>
      <b-form-group :label="$t('amount')" label-for="count">
        <validation-provider
          #default="{ errors }"
          :name="$t('amount')"
          rules="required"
        >
          <b-form-input
            id="count"
            v-model="form.count"
            @input="formatPrice(form.count, 'count')"
            onkeypress="return /[0-9,/.]/i.test(event.key)"
            :placeholder="$t('amount')"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
      <b-form-group :label="$t('destination_warehouse')" label-for="sum">
        <validation-provider
          #default="{ errors }"
          :name="$t('destination_warehouse')"
          rules="required"
        >
          <!-- {{GET_APPLICATION_TYPE}} -->
          <v-select
            id="sum"
            v-model="form.storage"
            :placeholder="$t('destination_warehouse')"
            label="title"
            :options="GET_APPLICATION_TYPE"
            :reduce="(option) => option.id"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </validation-observer>
  </b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { BModal, BFormGroup, BFormInput } from "bootstrap-vue";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";
import { required } from "@core/utils/validations/validations";

export default {
  components: {
    BModal,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormInput,
    vSelect,
  },
  data(){
    return {
      typeProduct: [
        {
          title: this.$t('sidebar.material'),
          value: "material",
        },
        {
          title: this.$t('sidebar.instrument'),
          value: "instrument",
        },
      ],
      type: "material",
      material: null,
      category: null,
      categoryMaterial: null,
      instrumentType: null,
      required,
      form: {
        name: "",
        count: "",
        storage: "",
        note: null,
      },
    }
  },
  computed: {
    ...mapGetters("application", ["GET_APPLICATION_TYPE"]),
    ...mapGetters("materials", [
      "GET_MATERIALS_FOR_ENTERING",
      "GET_MATERIALS",
      "GET_PRODUCT_CATEGORIES",
    ]),
    ...mapGetters("instruments", [
      "GET_INSTRUMENTS_FOR_ENTERING",
      "GET_INSTRUMENTS_MODEL",
      "GET_INSTRUMENT_CATEGORIES",
    ]),
  },
  async mounted() {
    await this.FETCH_APPLICATION_TYPE({ is_object: 1, mini: true });
    this.onSelectType(this.type);
  },
  methods: {
    ...mapActions("storage", [
      "CREATE_STORAGE_MATERIAL",
      "CREATE_STORAGE_INSTRUMENT",
    ]),
    ...mapActions("application", ["FETCH_APPLICATION_TYPE"]),
    ...mapActions("materials", [
      "FETCH_MATERIALS_FOR_ENTERING",
      "FETCH_MATERIALS",
      "FETCH_PRODUCT_CATEGORIES",
    ]),
    ...mapActions("instruments", [
      "FETCH_INSTRUMENTS_FOR_ENTERING",
      "FETCH_INSTRUMENTS_MODEL",
      "FETCH_INSTRUMENTS_CATEGORY",
    ]),
    ...mapActions("storage", ["CREATE_STORAGE_INSTRUMENT"]),

    async nextFuncEnter() {
      if (this.GET_MATERIALS_FOR_ENTERING.next) {
        const page = this.GET_MATERIALS_FOR_ENTERING.next;

        await this.FETCH_MATERIALS_FOR_ENTERING({
          page: page,
          pagination: "number",
        });
      }
    },

    async previousEnter() {
      if (this.GET_MATERIALS_FOR_ENTERING.previous) {
        const page = this.GET_MATERIALS_FOR_ENTERING.previous;

        await this.FETCH_MATERIALS_FOR_ENTERING({
          page: page,
          pagination: "number",
        });
      }
    },

    async onSearch1(query) {
      await this.FETCH_MATERIALS({ pagination: "number", search: query });
    },
    async previous() {
      if (this.GET_MATERIALS.previous) {
        const page = this.GET_MATERIALS.previous;

        await this.FETCH_MATERIALS({ page: page, pagination: "number" });
      }
    },

    async nextFunc() {
      if (this.GET_MATERIALS.next) {
        const page = this.GET_MATERIALS.next;

        await this.FETCH_MATERIALS({ page: page, pagination: "number" });
      }
    },

    // ===============  SEARCH_SECTION START ===============
    formatPrice(value, type) {
      if (value) {
        let currency = value.toString().replace(/,/g, "");
        currency = parseFloat(currency);
        currency = new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format(currency);

        if (type == "count") {
          this.form.count = currency;
        }
      }
      return 0;
    },
    // ===============  SEARCH_SECTION END ===============

    setNull() {
      this.categoryMaterial = null;
      this.material = null;
      this.form.name = "";
      this.form.count = "";
      this.form.storage = "";
      this.form.note = "";
    },

    async materialTypeGetByCategory(data) {
      // await this.FETCH_MATERIALS({ category: data.id });

      if (data == 0) {
        await this.FETCH_MATERIALS({ pagination: "number" });
        this.material = null;
      } else {
        await this.FETCH_MATERIALS({ category: data, pagination: "number" });
        this.material = null;
      }
    },
    onSelectMaterial(id) {
      this.form.name = null;
      this.FETCH_MATERIALS_FOR_ENTERING({ product: id });
    },
    onSelectCategory(id) {
      this.FETCH_INSTRUMENTS_MODEL({ category: id });
    },
    onSelectMaterialType(id) {
      this.FETCH_INSTRUMENTS_FOR_ENTERING({ type: id });
    },
    async onSelectType(type) {
      if (type == "material") {
        await this.FETCH_PRODUCT_CATEGORIES();
        this.GET_PRODUCT_CATEGORIES.results.unshift({
          id: 0,
          title: this.$i18n.locale == "ru" ? "Все" : "Barchasi",
        });
      } else {
        await this.FETCH_INSTRUMENTS_CATEGORY();
      }
    },
    addEnteringBalance() {
      this.$refs.validationObserver.validate().then((success) => {
        if (!success) return;
        this.form.count = parseFloat(this.form.count.toString().replace(/,/g, ""));
        const { name, count, storage, note } = this.form;
        if (this.type === "material") {
          this.CREATE_STORAGE_MATERIAL({
            goods: name,
            start_total: count,
            variable_total: count,
            storage,
            note,
          })
            .then(() => {
              this.setNull();
              this.$emit("refresh");
              this.$_okToast("Success");
              this.$bvModal.hide("addEnteringBalanceModal");
            })
            .catch(() => {
              this.$_errToast("Error");
            });
        } else {
          this.CREATE_STORAGE_INSTRUMENT({
            instrument: name,
            start_total: count,
            variable_total: count,
            storage,
            note,
          })
            .then(() => {
              this.setNull();
              this.$emit("refresh");
              this.$_okToast();
              this.$bvModal.hide("addEnteringBalanceModal");
            })
            .catch(() => {
              this.$_errToast("Error");
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.material .vs--disabled .vs__dropdown-toggle,
[dir] .vs--disabled .vs__clear,
[dir] .vs--disabled .vs__search,
[dir] .vs--disabled .vs__selected,
[dir] .vs--disabled .vs__open-indicator {
  cursor: not-allowed;
  background-color: transparent !important;
}

.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}
.pagination button {
  flex-grow: 1;
  border: 1px solid #ccc;
}
.pagination button:hover {
  cursor: pointer;
}
</style>